module.exports = __webpack_public_path__ + "img/overbooking.f3a437b9.svg";